import { useCallback, useEffect, useState } from "react"

import { ErrorBlock } from "components/controls/errorInfo"
import { DialogBase } from "components/dialog"
import { MessageDialog } from "components/dialog/message"

import {
	Box,
	List,
	ListItem,
	ListItemButton,
	Slide,
	Stack
} from "@mui/material"

import { NotificationResult, useListNotification, usePostNotificationReadIt } from "interface/notification"
import { NotificationDetail } from "../components/detail"
import { NotificationHeadline } from "../components/headLine"

type NotificationDialogProps = {
	onClose: () => void
	onChangeNotificationReadedCount: (count: number) => void
}
export const NotificationDialog = ({
	onClose,
	onChangeNotificationReadedCount
}: NotificationDialogProps) => {
	const [notifications, setNotifications] = useState<NotificationResult[]>([])
	const [openedNotification, setOpenedNotification] = useState<NotificationResult | null>(null)

	const queryStatus = useListNotification(false)
	useEffect(
		() => {
			setNotifications(queryStatus.data?.list ?? [])
		},
		[queryStatus]
	)
	useEffect(
		() => {
			onChangeNotificationReadedCount(
				notifications.filter(notification => (notification.readTime?.length ?? 0) === 0)?.length
			)
		},
		[notifications, onChangeNotificationReadedCount]
	)
	const onOpen = useCallback(
		(notification: NotificationResult) => {
			if (notification.description && notification.description.length > 0) {
				setOpenedNotification(notification)
			} else if (notification.url && notification.url.length > 0) {
				window.open(notification.url, '_blank')
			}
			setNotifications(
				...[notifications.map(exist => exist.notificationId === notification.notificationId ? notification : exist)]
			)
		},
		[setOpenedNotification, notifications, setNotifications]
	)
	const [readItStatus, readIt] = usePostNotificationReadIt({
		onPosted: onOpen
	})

	if (!queryStatus.loading && queryStatus.data?.list.length === 0) {
		return (
			<MessageDialog
				message="有効なお知らせがありません"
				onClose={onClose}
			/>
		)
	}
	return (
		<DialogBase
			open
			fullWidth
			maxWidth="sm"
			title={queryStatus.loading ? '読込中..' : `お知らせ（${notifications.length}件）`}
			isLoading={queryStatus.loading || readItStatus.posting}
			contentProps={{
				sx: {
					paddingX: 0,
          height: '60vh'
				}
			}}
			body={
				<Stack direction="column">
					{queryStatus.error && <ErrorBlock error={queryStatus.error}/>}
					{readItStatus.error && <ErrorBlock error={readItStatus.error}/>}

					<Box sx={{ position: "relative" }} flexGrow={1}>
						<Slide
							key="notification_list"
							direction="right"
							in={openedNotification === null}
							appear={false}
						>
							<List>
								{notifications.map(notification =>
									(notification.description && notification.description.length > 0) ? (
										<ListItemButton
											key={`notification_${notification.notificationId}`}
											onClick={() => readIt(notification.notificationId)}
											disableGutters
											disableRipple
											sx={{
												padding: 0
											}}
										>
											<ListItem>
												<NotificationHeadline
													notification={notification}
													isNew={(notification.readTime?.length ?? 0) === 0}
												/>
											</ListItem>
										</ListItemButton>
									) : (
										<ListItem key={`notification_${notification.notificationId}`}>
											<NotificationHeadline
												notification={notification}
												link={notification.url}
												isNew={(notification.readTime?.length ?? 0) === 0}
												onLinkClick={() => readIt(notification.notificationId)}
											/>
										</ListItem>
									)
								)}
							</List>
						</Slide>

						{openedNotification && (
							<Slide
								key="notification_detail"
								direction="left"
								in
								style={{
									position: "absolute",
									zIndex: 1,
									top: 0,
									left: 0,
									width: "100%"
								}}
							>
								<NotificationDetail notification={openedNotification}/>
							</Slide>
						)}
					</Box>
				</Stack>
			}
      action={{ onClose }}
			onClose={onClose}
			onBack={openedNotification !== null ? () => setOpenedNotification(null) : undefined}
		/>
	)
}